import { jsx as _jsx } from "react/jsx-runtime";
import { useEnvironmentConfig } from "../PlatformAuthProvider.js";
import { UsageTrackingProvider } from "./UsageTrackingProvider.js";
/** Usage recording for an app under `PlatformAuthProvider`, configured from `/management/api/config`. */
export function PlatformUsageTracking({ app, router, tenantId, accessLevel }) {
    const config = useEnvironmentConfig();
    if (!config)
        return null;
    return _jsx(UsageTrackingProvider, { app: app, config: config, router: router, tenantId: tenantId, accessLevel: accessLevel });
}
//# sourceMappingURL=PlatformUsageTracking.js.map